/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Dark_Polecat_EmbraceInputs */

const fr_vivid_dark_polecat_embrace = /** @type {(inputs: Vivid_Dark_Polecat_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identité de la salle`)
};

/**

* @param {Vivid_Dark_Polecat_EmbraceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vivid_dark_polecat_embrace = /** @type {((inputs?: Vivid_Dark_Polecat_EmbraceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Dark_Polecat_EmbraceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vivid_dark_polecat_embrace(inputs)
});